import { defineStore } from 'pinia'
import { useICPStore } from './icpStore';
import api from '@/services/api'
import {useGroupCallsStore} from "@/stores/groupCallsStore";
import {useCallsStore} from "@/stores/callsStore";
import {useContactsStore} from "@/stores/contactsStore";
import {useMediaStore} from "@/stores/mediaStore";
import {useSDSStore} from "@/stores/sdsStore";
import {useAlarmsStore} from "@/stores/alarmsStore";
import {notifyError} from "@/services/toastService";
import { keycloak } from '@/main';

export const useAuthStore = defineStore('auth', {
    state: () => ({
        // Does not keep the session active on page reload
        showLoginForm: true,
        rsp: null,
        loggedUser: "",
        operatorProfiles: [],
        loading: false,
        loggedUserProfile: ""
    }),
    actions: {

        fetchProfiles() {
            this.loading = true
            api.get('/mcx/getProfiles')
                .then(response => {
                    this.operatorProfiles = response.data;
                    this.loading = false;
                })
                .catch(error => {
                    console.error("There was an error fetching the list of operator profiles:", error);
                });
        },

        fetchCredentials(selectedProfile) {
            api.get('/mcx/getCredentials', {
                params: {
                    operatorProfile: selectedProfile.value
                }
            })
                .then(response => {
                    const mcxCredentials = response.data;
                    this.login(mcxCredentials.username, mcxCredentials.password, selectedProfile.value);
                })
                .catch(error => {
                    console.error("There was an error fetching mcx credentials for the operator:", error);
                });
        },

        async login(user, password, profile) {
            try {
                const icpStore = useICPStore();
                const ICP = icpStore.ICP;

                this.loggedUser = user;

                ICP.dispatch.auth.unifiedLogin({
                    user: user,
                    password: password,
                    force: true, //TODO: set false in prod
                    callback: (data) => {
                        console.log('Callback ricevuta:', data);
                        this.rsp = data.rsp;

                        if (this.rsp === '0') {
                            this.loggedUserProfile = profile;
                            this.showLoginForm = false;
                            sessionStorage.setItem('showLoginForm', 'true');
                        }
                    }
                });
            } catch (error) {
                console.error('Errore login ICPSDK:', error);
            }
        },

        async logout() {
            try {
                const icpStore = useICPStore();
                const ICP = icpStore.ICP;

                ICP.dispatch.auth.unifiedLogout({
                    callback: (data) => {
                        console.log('Callback logout ricevuta:', data);
                        this.rsp = data.rsp;

                        if (this.rsp === '0') {
                            this.showLoginForm = true;
                            sessionStorage.setItem('showLoginForm', 'false');
                            this.loggedUser = "";
                            this.operatorProfiles = [];
                            this.loggedUserProfile = "";
                            // Resetting all stores
                            useGroupCallsStore().$reset();
                            useCallsStore().$reset();
                            useContactsStore().$reset();
                            useMediaStore().$reset();
                            useSDSStore().$reset();
                            useAlarmsStore().$reset();
                            keycloak.logout({ redirectUri: window.location.origin });
                        }
                    }
                });
            } catch (error) {
                console.error('Errore logout ICPSDK:', error);
            }
        },

        forceLogout(msg) {
            notifyError(msg)
            this.showLoginForm = true;
            this.loggedUser = "";
            this.operatorProfiles = [];
            this.loggedUserProfile = "";
            // Resetting all stores
            useGroupCallsStore().$reset();
            useCallsStore().$reset();
            useContactsStore().$reset();
            useMediaStore().$reset();
            useSDSStore().$reset();
            useAlarmsStore().$reset();
        }
    }
});